"use strict";

import angular from "angular";

import moment from "moment";
import template from "./nanda-date.component.html";
import "./themes/nanda-date.component.scss";
import "./themes/nanda-date.component-dark.scss";

/**
 * @component NuNandaDate
 * O <nu-nanda-date> é um componente para date
 */

class NandaDateCtrl {
    constructor() {}
    $onInit() {
        this.monthsName = [
            "JAN",
            "FEV",
            "MAR",
            "ABR",
            "MAI",
            "JUN",
            "JUL",
            "AGO",
            "SET",
            "OUT",
            "NOV",
            "DEZ"
        ];
        this.month = this.monthsName[moment(this.date).utcOffset(0).month()];
        this.year = moment(this.date).utcOffset(0).year();
    }
}

const name = "nuNandaDate";
const def = {
    bindings: {
        date: "=",
        situation: "=",
        type: "="
    },
    controllerAs: "nandaDateCtrl",
    controller: NandaDateCtrl,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
